import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "#0000E7",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 8.75c-.686 0-1.25.564-1.25 1.25v7c0 .686.564 1.25 1.25 1.25h11c.686 0 1.25-.564 1.25-1.25v-7c0-.686-.564-1.25-1.25-1.25zM5.25 10A2.756 2.756 0 0 1 8 7.25h11A2.756 2.756 0 0 1 21.75 10v7A2.756 2.756 0 0 1 19 19.75H8A2.756 2.756 0 0 1 5.25 17z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5.25 12a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 5.75c-.686 0-1.25.564-1.25 1.25v7c0 .686.564 1.25 1.25 1.25h1a.75.75 0 0 1 0 1.5H5A2.756 2.756 0 0 1 2.25 14V7A2.756 2.756 0 0 1 5 4.25h11A2.756 2.756 0 0 1 18.75 7v1a.75.75 0 0 1-1.5 0V7c0-.686-.564-1.25-1.25-1.25zM8.25 16a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }